export default __webpack_public_path__ + "static/media/sci-fi.24651987.png";